// Basiert auf https://gitlab.pooliestudios.com/koeln-marathon/app/app-dev

import {Runner} from '../models/runner';
import {
    RUN_FULL,
    RUN_HALF,
    RUN_RELAY,
    WaypointInterface,
} from '../models/waypoint';

declare global {
    interface Window {
        config?: {
            paths?: Array<never>,
            themePath?: string,
            googleMapsApiKey?: string,
            environment?: string,
            language?: string,
        };
    }
}

export default class PathProvider {
    pathFull: Array<WaypointInterface> = [];

    pathRelay: Array<WaypointInterface> = [];

    pathHalf: Array<WaypointInterface> = [];

    constructor() {
        if (window?.config?.paths) {
            this.pathFull = window.config.paths[RUN_FULL];
            this.pathRelay = window.config.paths[RUN_RELAY];
            this.pathHalf = window.config.paths[RUN_HALF];
        }
    }

    getPath(run: string): Array<WaypointInterface> {
        switch (run) {
            case RUN_FULL:
                return this.pathFull;
            case RUN_RELAY:
                return this.pathRelay;
            case RUN_HALF:
                return this.pathHalf;
            default:
                return null;
        }
    }

    getPathForRunner(runner): Array<WaypointInterface> {
        return this.getPath(runner.run);
    }

    getPathPositionsForRun(run): Array<google.maps.LatLng> {
        return this.getPath(run)
            .map((waypoint) => waypoint.position);
    }

    getPathIndexByDistance(runner: Runner, distance: number): number {
        const path = this.getPathForRunner(runner);
        let index = 0;

        path.every((waypoint, waypointIndex) => {
            if (distance <= waypoint.distance) {
                index = waypointIndex - 1;
                return false;
            }

            return true;
        });

        return index >= 0 ? index : 0;
    }

    getRunnerPositionByDistanceInterpolated(runner: Runner): google.maps.LatLng {
        const path = this.getPathForRunner(runner);

        if (!runner.hasStarted()) {
            return path[0].position;
        }

        const distanceInterpolated = runner.getDistanceInterpolated();

        const nearestIndex = this.getPathIndexByDistance(runner, distanceInterpolated);
        const nearestPathPosition = path[nearestIndex].position;

        const Spherical = google.maps.geometry.spherical;

        if (nearestIndex !== path.length - 1) {
            const nextPathCoordinate = path[nearestIndex + 1].position;
            const distanceDelta = distanceInterpolated - path[nearestIndex].distance;
            const headingCurrent = Spherical.computeHeading(nearestPathPosition, nextPathCoordinate);

            return Spherical.computeOffset(nearestPathPosition, distanceDelta * 1000, headingCurrent);
        }

        return nearestPathPosition;
    }
}
